import layoutHeaderAside from '@/layout/header-aside'
const meta = { auth: true }
export default {
  path: '/cep/',
  name: '采编发',
  meta,
  redirect: { name: 'cep/article' },
  component: layoutHeaderAside,
  children: (pre => [
    {
      path: 'guest-article',
      name: 'guest-article',
      meta: {
        title: '来稿库',
        auth: true
      },
      component: () => import('@/views/cep/guest-article/index')
    },
    {
      path: 'guest-article-review',
      name: 'guest-article-review',
      meta: {
        title: '来稿审核',
        auth: true
      },
      component: () => import('@/views/cep/guest-article/review')
    },
    {
      path: 'article/my-submit',
      name: 'article/my-submit',
      meta: {
        title: '我的投稿',
        auth: true
      },
      component: () => import('@/views/cep/article/submit')
    },
    {
      path: 'article/wx',
      name: 'article/wx',
      meta: {
        title: '微信组稿',
        auth: true
      },
      component: () => import('@/views/cep/wx/manuscript')
    },
    {
      path: 'cloudEditor',
      name: 'cloudEditor',
      meta: {
        title: '云编辑',
        auth: true
      },
      component: () => import('@/views/cep/cloudEditor/cloudEditor')
    },
    {
      path: 'videoAudit',
      name: 'videoAudit',
      meta: {
        title: '视频审核',
        auth: true
      },
      component: () => import('@/views/cep/cloudEditor/videoAudit')
    },
    {
      path: 'contentAyalysis',
      name: 'contentAyalysis',
      meta: {
        title: '内容分析',
        auth: true
      },
      component: () => import('@/views/cep/cloudEditor/contentAyalysis')
    },
    {
      path: 'wx/add',
      name: 'wx/add',
      meta: {
        title: '微信添加',
        auth: true
      },
      component: () => import('@/views/cep/wx/add')
    },
    // {
    //   path: 'article/submit-review',
    //   name: 'article/submit-review',
    //   meta: {
    //     title: '投稿审核',
    //     auth: true
    //   },
    //   component: () => import('@/views/cep/article/submitReview')
    // },
    {
      path: 'topic',
      name: 'cep-topic',
      meta: {
        title: '选题管理',
        auth: true
      },
      component: () => import('@/views/cep/topic/index')
    },
    {
      path: 'topic/calendar/new',
      name: 'topic-calendar-new',
      meta: {
        title: '选题申报',
        auth: true
      },
      component: () => import('@/views/cep/topic-calendar/new')
    },
    {
      path: 'topic/calendar',
      name: 'topic-calendar',
      meta: {
        title: '选题库',
        auth: true
      },
      component: () => import('@/views/cep/topic-calendar/index')
    },
    {
      path: 'topic/review',
      name: 'topic-admin',
      meta: {
        title: '选题管理',
        auth: true
      },
      component: () => import('@/views/cep/topic/review')
    },
    {
      path: 'topic/my',
      name: 'cep-topic-my',
      meta: {
        title: '我的选题',
        auth: true
      },
      component: () => import('@/views/cep/topic/my')
    },
    {
      path: 'bookmark',
      name: 'bookmark',
      meta: {
        title: '我的收藏',
        auth: true
      },
      component: () => import('@/views/cep/bookmark/index')
    },
    {
      path: 'publish',
      name: 'publish',
      meta: {
        title: '发布审核',
        auth: true
      },
      component: () => import('@/views/cep/publish/index')
    },
    {
      path: 'publish/history',
      name: 'publish-history',
      meta: {
        title: '发布记录',
        auth: true
      },
      component: () => import('@/views/cep/publish/history')
    },
    {
      path: 'article/new',
      name: `article/new`,
      meta: {
        title: '新建作品',
        auth: true
      },
      component: () => import('@/views/cep/article/createWizward')
    },
    {
      path: 'article/review-list',
      name: 'article-review-list',
      meta: {
        title: '作品审核',
        auth: true
      },
      component: () => import('@/views/cep/article/reviewList')
    },
    {
      path: 'article',
      name: `${pre}article`,
      meta: {
        title: '作品库',
        auth: true
      },
      component: () => import('@/views/cep/article/index1')
    },
    {
      path: 'article/review',
      name: 'article/review',
      meta: {
        title: '审核记录',
        auth: true
      },
      component: () => import('@/views/cep/article/review')
    },
    // {
    //   path: 'article/update',
    //   name: 'article/update',
    //   meta: {
    //     title: '稿件编辑',
    //     auth: true
    //   },
    //   component: () => import('@/views/cep/article/update')
    // },
    {
      path: 'article/update',
      name: 'article/update',
      meta: {
        title: '稿件编辑',
        auth: true
      },
      component: () => import('@/views/cep/article/update2')
    },
    // 临时路由 质量检测
    {
      path: 'article/QualityInspectionComponent',
      name: 'article/QualityInspectionComponent',
      meta: {
        title: '质量检测',
        auth: true
      },
      component: () => import('@/views/cep/article/components/QualityInspection/QualityInspectionComponent')
    },
    {
      path: 'article/preview',
      name: 'article/preview',
      meta: {
        title: '稿件预览',
        auth: true
      },
      component: () => import('@/views/cep/article/preview')
    },
    {
      path: 'insight/top',
      name: 'insight-top',
      meta: {
        title: '最新事件',
        auth: true
      },
      component: () => import('@/views/cep/insight/top')
    },
    {
      path: 'insight/hot',
      name: 'insight-hot',
      meta: {
        title: '热点发现',
        auth: true
      },
      component: () => import('@/views/cep/insight/hot')
    },
    {
      path: 'insight/monitor',
      name: 'insight-monitor',
      meta: {
        title: '热点方案',
        auth: true
      },
      component: () => import('@/views/cep/insight/monitor')
    }])('cep/')
}
